<template>
  <div class="nav">
    <router-link v-if="next_item" :to=" '/project/' + next_item.url_title ">
      <p>next</p>
      <p class="nextTitle">{{ next_item.title }}</p>
    </router-link>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  name: "AlbumNav",
  computed: {
    ...mapGetters(["next_item"])
  }
};
</script>

<style scoped lang="scss">
.nav {
  font-size: 1rem;

  @include mediumScreen {
    margin: 4rem 0 -7rem;
    text-align: right;
  }

  .nextTitle {
    font-size: 1.2em;
    font-weight: 800;

    @include mediumScreen {
      font-size: 1.5em;
    }
    @include bigScreen {
      font-size: 3em;
    }
  }
}
</style>
